import PropTypes from 'prop-types';
// import searchFill from '@iconify/icons-eva/search-fill';
// material
import { styled } from '@mui/material/styles';
import { Toolbar, OutlinedInput, InputAdornment } from '@mui/material';
import Iconify from '../../../components/iconify';
// ----------------------------------------------------------------------

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
    maxWidth: 300,
    minWidth: 120,
    height: 40,
    backgroundColor: theme.palette.background.paper,
    border:'1px solid',
    borderColor: theme.palette.grey[300],
    transition: theme.transitions.create(['box-shadow', 'width'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shorter
    }),
    '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
    '& fieldset': {
        borderWidth: `0px !important`,
        borderColor: `${theme.palette.grey[500_32]} !important`,
        // borderTopLeftRadius:'25px',
        // borderBottomLeftRadius:'25px',
        // borderTopRightRadius:'25px',
        // borderBottomRightRadius:'25px'
        borderRadius: 8,
    }
}));
const RootStyle = styled(Toolbar)(({ theme }) => ({
    height: 90,
    display: 'flex',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 1, 0, 3)
}));

// ----------------------------------------------------------------------

DealerSearchbar.propTypes = {
    filterName: PropTypes.string,
    onFilterName: PropTypes.func
};

export default function DealerSearchbar({ filterName, onFilterName }) {

    return (
        <RootStyle>
            <SearchStyle
                value={filterName}
                onChange={onFilterName}
                placeholder="Search"
                startAdornment={
                    <InputAdornment position="start">
                        {/* <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} /> */}
                        <Iconify icon="eva:search-fill" width='18px' height='18px' />
                    </InputAdornment>
                }
            />
        </RootStyle>
    );
}
